import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Register Service Worker for Push Notifications
// Also auto-triggers a page reload when a new SW takes control (fixes stale-cache after redeploy)
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js')
      .then(registration => {
        console.log('SW registered:', registration.scope);

        // Check for updates on every load
        registration.update().catch(() => {});

        // When a new SW is waiting to activate → tell it to skip waiting immediately
        const promptUpdate = (worker) => {
          worker.postMessage({ type: 'SKIP_WAITING' });
        };
        if (registration.waiting) promptUpdate(registration.waiting);
        registration.addEventListener('updatefound', () => {
          const installing = registration.installing;
          if (!installing) return;
          installing.addEventListener('statechange', () => {
            if (installing.state === 'installed' && navigator.serviceWorker.controller) {
              promptUpdate(installing);
            }
          });
        });
      })
      .catch(error => {
        console.log('SW registration failed:', error);
      });

    // When the new SW takes control, refresh the page ONCE so the user immediately gets fresh UI
    let hasReloaded = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (hasReloaded) return;
      hasReloaded = true;
      window.location.reload();
    });
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
